import api from "./controllersApi";

export const fetchHome = (params = {}) =>
  api.get("api/home/home", { params });

export const fetchHomeExtra = (params = {}) =>
  api.get("api/home/HomeExtra", { params });

export const fetchHomeInfo = (params = {}) =>
  api.get("api/home/HomeInfo", { params });

export const fetchHomeSlides = (params = {}) =>
  api.get("api/home/slides", { params });
